const stats = [
  { value: '128+', label: '今日更新' },
  { value: '3280+', label: '收录作品' },
  { value: '580w+', label: '追更用户' },
  { value: '9.8', label: '用户评分' },
];

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[560px] w-full items-center overflow-hidden md:min-h-[640px]" aria-label="首屏">
      {/* background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=playful%20cartoon%20doodle%20background%20with%20floating%20funny%20emoticon%20faces%20and%20speech%20bubbles%2C%20stars%20squiggles%20and%20sparkles%20scattered%20around%2C%20warm%20orange%20cream%20and%20coral%20tones%2C%20lighthearted%20cheerful%20vector%20illustration%20without%20text%2C%20soft%20high%20key%20atmosphere&width=1600&height=900&seq=hero-comic-bg-2026&orientation=landscape"
          alt="哈哈漫画网 欢快漫画主题背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/35 to-background-50/95"></div>
      </div>

      {/* floating decorations */}
      <div className="pointer-events-none absolute inset-0 hidden lg:block" aria-hidden="true">
        <i className="ri-emotion-laugh-fill absolute left-[10%] top-[22%] animate-floaty text-5xl text-secondary-400/90"></i>
        <i className="ri-emotion-happy-fill absolute right-[12%] top-[26%] animate-floaty text-6xl text-accent-400/90" style={{ animationDelay: '0.8s' }}></i>
        <i className="ri-emotion-laugh-line absolute right-[24%] bottom-[20%] animate-floaty text-5xl text-secondary-300/90" style={{ animationDelay: '1.4s' }}></i>
        <i className="ri-star-smile-fill absolute left-[18%] bottom-[24%] animate-floaty text-4xl text-accent-300/90" style={{ animationDelay: '0.4s' }}></i>
      </div>

      {/* content */}
      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-24 md:px-6 md:py-32">
        <div className="max-w-2xl animate-pop">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/20 px-4 py-1.5 text-sm text-background-50 backdrop-blur-sm">
            <i className="ri-fire-line text-secondary-300" aria-hidden="true"></i>
            全网爆笑合集 · 每日更新
          </span>
          <h1 className="mt-6 font-heading text-4xl leading-tight text-background-50 md:text-6xl">
            每天笑一笑
            <br />
            生活没烦恼
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-background-100 md:text-lg">
            汇集全网搞笑漫画与爆笑漫画合集，从幽默短篇到笑死人不偿命的神作。一键追更不迷路，专治不开心，笑到肚子疼算我输。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#comics"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-base font-medium text-background-50 shadow-lift transition-colors hover:bg-primary-600"
            >
              <i className="ri-arrow-right-down-line" aria-hidden="true"></i>
              去笑一笑
            </a>
            <a
              href="#categories"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/60 px-7 py-3 text-base text-background-50 transition-colors hover:bg-background-50/15"
            >
              <i className="ri-grid-fill" aria-hidden="true"></i>
              浏览分类
            </a>
          </div>

          {/* stats */}
          <dl className="mt-12 grid max-w-xl grid-cols-2 gap-x-6 gap-y-6 sm:grid-cols-4">
            {stats.map((s) => (
              <div key={s.label}>
                <dt className="sr-only">{s.label}</dt>
                <dd className="font-heading text-2xl text-background-50 md:text-3xl">{s.value}</dd>
                <dd className="mt-1 text-xs text-background-200 md:text-sm">{s.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}